import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';

import Logo from 'assets/logo@2x.png';
import Menu from './Menu.styles';
import NavSection from './NavSection';

const LinkBasic = ({ children, ...rest }) => (
  <a {...rest}>
    <div className="Menu__item">{children}</div>
  </a>
);

const LinkItem = ({ children, ...rest }) => (
  <Link {...rest}>
    <div className="Menu__item">{children}</div>
  </Link>
);

class MenuContainer extends Component {
  componentDidMount() {
    this.unlisten = this.props.history.listen((location, done) => {
      this.props.toggleMenu(false);
    });
  }
  componentWillUnmount() {
    this.unlisten();
  }
  shouldComponentUpdate() {
    return false;
  }
  render() {
    return (
      <Menu>
        <header className="Menu__header">
          <Link to="/">
            <img className="Menu__logo" src={Logo} alt="Chris Tieman" />
          </Link>
        </header>
        <section className="Menu__navigation">
          <NavSection title="Navigation">
            <LinkItem to="/">Home</LinkItem>
            <LinkItem to="/skills">Skills</LinkItem>
            <LinkItem to="/work">Work</LinkItem>
            <LinkBasic href="mailto:hello@christieman.com">Contact</LinkBasic>
          </NavSection>
          <NavSection title="Connect">
            <LinkBasic href="https://github.com/ducky" target="_blank">
              GitHub
            </LinkBasic>
            <LinkBasic href="https://linkedin.com/in/christieman/" target="_blank">
              LinkedIn
            </LinkBasic>
          </NavSection>
        </section>
      </Menu>
    );
  }
}

export default withRouter(MenuContainer);



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.container.js